/* eslint-disable no-useless-constructor */
import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import { Link } from 'react-router-dom'
import ActionButton from '../ActionButton/ActionButton'
import Icon from '../Icon/Icon'
import TncModalLink from '../../home/TncModalLink/TncModalLink'
//import BrandLogo from '../../branding/Logo/Logo'
import BrandLogo from '../../../assets/img/ayala-malls-logo.svg'

// import ZingLogo from '../../../assets/img/zing-logo.webp'
// import Tiktok from '../../../assets/img/social/tiktok.svg'
import Facebook from '../../../assets/img/social/fb.png'
import Instagram from '../../../assets/img/social/in.png'
import Youtube from '../../../assets/img/social/yt.png'

import media from '../../../services/generateMediaQueries'
import downloadAppLink from '../../../services/redirection/downloadAppLink'
// import ResponsiveAdsContainer from '../../ads/ResponsiveAdsContainer/ResponsiveAdsContainer'
// import DesktopLeaderboard from '../../ads/DesktopLeaderboard/DesktopLeaderboard'
// import MobileRectangle from '../../ads/MobileRectangle/MobileRectangle'

const StyledFooter = styled.div`
  margin-top: -12rem;
  padding-top: 14rem;
  background: ${props => props.background || '#000000'};

  color: #ffffff;
  overflow: auto;

  ${media.lessThan('medium')`
    margin-top: -10.5rem;
  `}
`

const Container = styled.div`
  max-width: 1024px;
  margin: 0 auto;
`
const StyledTncModalLink = styled(TncModalLink)`
  color: var(--color-primary);
`
const StoreDownload = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
const StoreBubbles = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: center;

  ${media.lessThan('medium')`
    justify-content: center;
    flex-direction: column;
  `}
`
const DownloadHeader = styled.p`
  font-weight: var(--font-weight);
  font-size: 1.6rem;
  text-align: center;
  margin-top: 0;
  margin-bottom: 0.8rem;
  line-height: 1.6rem;
  letter-spacing: var(--letter-spacing-wider);
`
const MainFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 115px;
  align-items: flex-end;

  font-size: 0.875rem;

  ${media.lessThan('large')`
    padding: 0 27px;
    flex-direction: column;
    align-items: center;
  `}

  ${props =>
    props.footerSmall &&
    css`
      margin-top: 75px;
    `}
`
const FooterBrand = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  ${media.lessThan('large')`
    align-items: center;
    text-align: center;
  `}
`
const AyalaLogo = styled.img.attrs({ src: BrandLogo })`
  margin-bottom: 1.25rem;
  margin-left: -15px;
  width: 250px;

  ${media.lessThan('medium')`
    margin-bottom: 1.875rem;
  `}
`
const FooterNav = styled.ul`
  max-width: 100%;
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  margin-bottom: 5px;
  flex-wrap: wrap;

  ${media.lessThan('large')`
    justify-content: center;
    margin-bottom: 20px;
  `}
`
const FooterNavItem = styled.li`
  margin-right: 1em;
  white-space: nowrap;
  letter-spacing: var(--letter-spacing-wider);
  a {
    color: #ffffff;

    &:hover {
      color: var(--color-primary-hover);
    }
  }

  ${media.lessThan('large')`
    margin-right: 20px;
    margin-bottom: 5px;
  `}
`
export const StoreOption = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`
const StyledLink = styled(Link)`
  color: #ffffff !important;
  text-decoration: none;

  &:hover {
    color: var(--color-primary-hover) !important;
  }
`
const PrivacyPolicyLink = styled.a`
  color: #ffffff !important;
  text-decoration: none !important;

  &:hover {
    color: var(--color-primary-hover) !important;
  }
`
const Text = styled.p`
  margin: 0;
  letter-spacing: var(--letter-spacing-wider);
`
const FooterSocials = styled.div`
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  flex: 0;
  align-items: flex-end;
  text-align: right;

  ${media.lessThan('large')`
    align-items: center;
    text-align: center;
  `}
`
const SocialsButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 120px;
  margin-bottom: 16px;
  margin-top: 8px;

  ${media.lessThan('large')`
    margin: 40px 0;
  `}
`
const PoweredBy = styled.p`
  margin: 0;
  margin-bottom: 5px;
  letter-spacing: var(--letter-spacing-wider);
`
const FooterLink = styled.a`
  color: #ffffff !important;
  text-decoration: none;
  img {
    width: 32px;
  }
  &:hover {
    color: var(--color-primary-hover) !important;
  }
`
// revert for release
// const BrandLogo = styled.img.attrs({ src: ZingLogo })`
//   height: 90px;
// `

class Footer extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { footerSmall, background, altFooterAd, ...restProps } = this.props

    return (
      <StyledFooter background={background} {...restProps}>
        {!footerSmall && (
          <>
            <StoreDownload>
              <DownloadHeader>Download the App Now!</DownloadHeader>
              <StoreBubbles>
                <StoreOption>
                  <ActionButton
                    style={{ width: '230px' }}
                    variant="primary"
                    icon={<Icon name="appstore" />}
                    onClick={downloadAppLink('iOS')}
                  >
                    App store
                  </ActionButton>
                </StoreOption>
                <StoreOption>
                  <ActionButton
                    style={{ width: '230px' }}
                    variant="primary"
                    icon={<Icon name="playstore" />}
                    onClick={downloadAppLink('Android')}
                  >
                    Google play
                  </ActionButton>
                </StoreOption>
              </StoreBubbles>
            </StoreDownload>
          </>
        )}
        <Container>
          <MainFooter footerSmall>
            <FooterBrand>
              <AyalaLogo />
              <FooterNav>
                <FooterNavItem>
                  <StyledLink to="/main/malls">Our Malls</StyledLink>
                </FooterNavItem>
                <FooterNavItem>
                  <StyledTncModalLink>Terms and Conditions</StyledTncModalLink>
                </FooterNavItem>
                <FooterNavItem>
                  <PrivacyPolicyLink
                    // href="/webview/privacy-notice" // revert for release
                    href="/webview/ayalamalls-website-privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Notice
                  </PrivacyPolicyLink>
                </FooterNavItem>
              </FooterNav>
              <Text>
                Copyright © 2019 AyalaLand Malls, Inc. All Rights Reserved
              </Text>
            </FooterBrand>
            <FooterSocials>
              <SocialsButtonContainer>
                <FooterLink
                  // href="https://www.facebook.com/zingbyayalamalls" - revert for release
                  href="https://www.facebook.com/AyalaMalls360"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={Facebook} alt="" />
                </FooterLink>
                <FooterLink
                  // href="https://instagram.com/zingayalamalls" - revert for release
                  href="https://www.instagram.com/iloveayalamalls/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={Instagram} alt="" />
                </FooterLink>
                {/* <FooterLink - revert for release
                  href="https://www.tiktok.com/@iloveayalamalls"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={Tiktok} alt="" />
                </FooterLink> */}
                <FooterLink
                  href="https://www.youtube.com/channel/UCkZGCcsk7YZ_QcgP6hwcJrQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={Youtube} alt="" />
                </FooterLink>
              </SocialsButtonContainer>
              <PoweredBy>
                <FooterLink
                  href="https://www.whitecloak.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Powered by White Cloak Technologies Inc.
                </FooterLink>
              </PoweredBy>
              <Text>
                <FooterLink
                  href="https://www.whitecloak.com"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                >
                  www.whitecloak.com
                </FooterLink>
              </Text>
            </FooterSocials>
          </MainFooter>
        </Container>
      </StyledFooter>
    )
  }
}

Footer.defaultProps = {
  cmsMalls: [],
}

Footer.propTypes = {
  cmsMalls: PropTypes.array,
}

export default Footer
